<div #settingsContent class="settings-content">
    <div class="settings-header">
        <div class="settings-title">{{ messages.title }}</div>
        @if (showDoneButton) {
            <div class="settings-close" (click)="onSettingsClose()">
                {{ linearMessages.settingsDone }}
            </div>
        } @else {
            <i class="theme-ex" (click)="onSettingsClose()"></i>
        }
    </div>
    <div class="settings-content__container">
        <div class="settings-section-header">{{ linearMessages.settingsAcceptanceTitle }}</div>
        @if (oddsConfig.showOddsAcceptanceSettings) {
            <div class="settings-odds-acceptance">
                <ds-radio-group size="medium" [value]="selectedOddAcceptance">
                    <ds-radio-button name="oddsSettingsAcceptance" [value]="acceptance.Any" (click)="onOddsAcceptanceSelected(acceptance.Any)">
                        <div>
                            {{ messages.acceptAnyOdds }}
                            <p class="settings-odds-acceptance-any-info">{{ messages.acceptAnyExperience }}</p>
                        </div>
                    </ds-radio-button>

                    <ds-radio-button name="oddsSettingsAcceptance" [value]="acceptance.Higher" (click)="onOddsAcceptanceSelected(acceptance.Higher)">
                        {{ messages.acceptHigher }}
                    </ds-radio-button>
                    @if (!oddsConfig.hideDontAcceptOptionSetting) {
                        <ds-radio-button name="oddsSettingsAcceptance" [value]="acceptance.No" (click)="onOddsAcceptanceSelected(acceptance.No)">
                            {{ messages.acceptNoChanges }}
                        </ds-radio-button>
                    }
                </ds-radio-group>
            </div>
        }
        <p class="settings-tac" [innerHTML]="messages.acceptTac"></p>
        @if (!hideNotificationsSection) {
            <div class="settings-section-header settings-section-header--notifications">
                {{ linearMessages.settingsNotificationsTitle }}
            </div>
        }
        <div class="settings-notifications">
            @if (!hideAppNotificationCheckBox) {
                <ng-container *ngTemplateOutlet="notificationCheckBox; context: { type: notifyTypes.App }" />
            }
            <ng-container *ngTemplateOutlet="notificationCheckBox; context: { type: notifyTypes.Email }" />
        </div>
    </div>
</div>
<ng-template #notificationCheckBox let-type="type" let-vm="vm" let-info="info">
    @if (notificationsViewModel[type].visible) {
        <div class="settings-notification__check-container" [ngClass]="{ disabled: !notificationsViewModel[type].enabled }">
            <ds-checkbox
                name="betslip-settings-{{ type }}-notify"
                size="medium"
                ngDefaultControl
                [disabled]="!notificationsViewModel[type].enabled"
                [checked]="notificationsViewModel[type].value"
                (checkedChange)="onNotificationToggled($event, type)">
                {{ notificationsViewModel[type].label }}
            </ds-checkbox>
            @if (info) {
                <span class="settings-notification__info">({{ info }})</span>
            }
        </div>
    }
</ng-template>
